import { getPersisted } from 'utils/persistor'
import { constants } from 'consts'

import { theme as muiTheme } from './muiTheme'
import { theme as lightTheme } from './lightTheme'
import { theme as whiteTheme } from './whiteTheme'

export const themes = [
  { id: 'mui', name: 'Material UI', theme: muiTheme },
  { id: 'light', name: 'Light', theme: lightTheme },
  { id: 'white', name: 'White', theme: whiteTheme }
]

export const loadTheme = () => {
  const themeId = getPersisted(constants.THEME_KEY, constants.DEFAULT_THEME)
  return themes.find(x => x.id === themeId)
}
